module.exports = __webpack_public_path__ + "static/media/EAI-02.9e69c4ea.jpg";